jQuery(document).ready(function( $ ){
	// START JQUERY

	logit = (typeof logit !== 'undefined')? logit : false;

	videoloop_enable = (typeof videoloop_enable !== 'undefined')? videoloop_enable : false;
	videoloop_id = (typeof videoloop_id !== 'undefined')? videoloop_id : "videoloop-player";

	videoloop_skip_last = (typeof videoloop_skip_last !== 'undefined')? videoloop_skip_last :  1; // min 1
	videoloop_skip_first = (typeof videoloop_skip_first !== 'undefined')? videoloop_skip_first :  1;

	videofix_autoplay_enable = (typeof videofix_autoplay_enable !== 'undefined')? videofix_autoplay_enable :  true;
	videofix_autoplay_target = (typeof videofix_autoplay_target !== 'undefined')? videofix_autoplay_target :  'videoloop-player';
	videofix_autoplay_click_id = (typeof videofix_autoplay_click_id !== 'undefined')? videofix_autoplay_click_id :  'mainNavbar';

	if(videoloop_enable && videoloop_id) {
		if(logit) console.log('[VIDEO LOOP] Enabled: ' + videoloop_id);
		if(logit == 2) console.log('[VIDEO LOOP] Skip first: ' + videoloop_skip_first + ', last: ' + videoloop_skip_last + ' s.');

		var videoloop = document.getElementById(videoloop_id);

		if(videoloop) {
				var videoloop_duration = videoloop.duration;
				videoloop.addEventListener("timeupdate", function () {
						if (!videoloop_duration) {
								videoloop_duration = (videoloop.duration - videoloop_skip_last);
								//if(logit == 2) console.log('[VIDEO LOOP] Clock:' + (videoloop_duration - this.currentTime));
								if(this.currentTime >= videoloop_duration) {
									  if(logit == 2) console.log('[VIDEO LOOP] RELOOP - Duration: ' + videoloop.duration + ' time: ' + this.currentTime);
										this.currentTime = videoloop_skip_first;
								}
						} else {
								videoloop_duration = 0;
								//if(logit == 2) console.log('[VIDEO LOOP] Duration:' + videoloop.duration);
						}
				});
		}
	} else {
		if(logit == 2) console.log('[VIDEO LOOP] Disabled');
		if(logit == 2) console.log('[VIDEO LOOP] add javascript variable videoloop_enable & videoloop_id (html id of video element) to start. Other variables: videoloop_skip_first, videoloop_skip_last');
	}

	if(videofix_autoplay_enable) {


		//function detectBrowser() {

		let isMobile = window.matchMedia("(pointer:coarse)").matches;

    let userAgent = navigator.userAgent;
    let browserName;

    if (userAgent.match(/chrome|chromium|crios/i)) {
      browserName = "Chrome";
    } else if (userAgent.match(/firefox|fxios/i)) {
      browserName = "Firefox";
    } else if (userAgent.match(/safari/i)) {
      browserName = "Safari";
    } else if (userAgent.match(/opr\//i)) {
      browserName = "Opera";
    } else if (userAgent.match(/edg/i)) {
      browserName = "Edge";
    } else if (userAgent.match(/android/i)) {
      browserName = "Android";
    } else if (userAgent.match(/iphone/i)) {
      browserName = "iPhone";
    } else {
      browserName = "Unknown";
    }

    //}

		if(logit == 2) console.log('[VIDEOFIX] running '+ browserName + ' mobile ' +  isMobile);


		if(browserName == "Chrome" && isMobile) {
			if(logit == 1) console.log('[VIDEOFIX] Fixed ');
			// Click a random element
			document.getElementById(videofix_autoplay_click_id).click();
			// Play video after click
			setTimeout(function(){
			    document.getElementById('video').play();
			}, 1500);
		}




	}




	// END JQUERY
});
